module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Arrows-8067aa9dee452e1cb75b870a3194255395da5ce188ae66c27a2e228d7faaec61.svg";